export default __webpack_public_path__ + "static/media/arrow-up.inline.a7395182.svg";